export default __webpack_public_path__ + "static/media/trophy.d8f09f18.png";